import type { BoardRecord, FunnelBoardProject } from "../types";

export function safeFilename(name: string): string {
  const cleaned = name
    .normalize("NFKD")
    .replace(/[^a-zA-Z0-9\s_-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .slice(0, 80);
  return cleaned || "funnelboard";
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1_000);
}

export function projectBlob(board: BoardRecord): Blob {
  const project: FunnelBoardProject = {
    format: "funnelboard",
    version: 1,
    exportedAt: new Date().toISOString(),
    board,
  };
  return new Blob([JSON.stringify(project, null, 2)], { type: "application/json" });
}

